export class DevicePackageSyncState {
  public packageId: number
  public schoolId: number
  public message: string
  public stage: number
  public totalItems: number
  public totalBytes: number
  public totalFiles: number
  public syncItems: number
  public syncBytes: number
  public transferredBytes: number
  public percentDone: number
  public totalPercentageDone: number
  public totalPercentageDone2: number
  public jobState: number
  public total: number
  public toCheck: number
  public rate: number
  public xfer: number
}
